import { ofType, Epic, StateObservable } from 'redux-observable';
import { mergeMap, Observable } from 'rxjs';
import * as L from 'lodash';
import { resetPaymentStateOnInit } from 'src/js/enrol/containers/payment/actions/Actions';
import { FINISH_CHECKOUT_PROCESS, resetCheckoutState } from '../actions/Actions';
import { IshState } from '../../services/IshState';
import {
  setResultDetailsAmount,
  setResultDetailsContacts,
  setResultDetailsCorporatePass
} from '../containers/summary/actions/Actions';
import { ContactPropsBy } from '../containers/summary/Summary';
import { IAction } from '../../actions/IshAction';

/**
 * This epic process Init action of checkout application and define Phase of the application
 */
export const FinishCheckoutProcess: Epic<any, any> = (action$: Observable<IAction>, store: StateObservable<IshState>): Observable<any> => {
  return action$.pipe(
    ofType(FINISH_CHECKOUT_PROCESS),
    mergeMap(() => {

      const state = store.value;

      const contacts = state.checkout.summary.result.map(id => {
        return ContactPropsBy(id, state);
      });

      const corporatePass = state.checkout.summary.resultDetails &&
        state.checkout.summary.resultDetails.corporatePass;

      return [
        resetPaymentStateOnInit(),
        resetCheckoutState(),
        setResultDetailsAmount(state.checkout.amount.ccPayment),
        setResultDetailsContacts(contacts),
        setResultDetailsCorporatePass(L.cloneDeep(corporatePass))
      ];
    })
  );
};
